<template>
    <header class="header">
        <Navigation />
    </header>
</template>

<script>
    import Navigation from  "@/components/partials/Navigation";
    export default {
        name: "Header",
        components: {
            Navigation
        },
        data(){
            return{
                lang: ""
            }
        },
        computed: {

        }
    }
</script>

<style scoped>

</style>